export enum UserRole {
    ADMIN = 'ADMIN',
    SUPERADMIN = 'SUPERADMIN',
    UPLOADER = 'UPLOADER',
    USER = 'USER',
}
